export const getPickupTimeSlots = (pickupTimeInterval) => {
  const value = Number(pickupTimeInterval);
  const interval = [15, 30, 60].includes(value) ? value : 15;
  const formatTime = (minutes) =>
    `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;

  return Array.from({ length: 1440 / interval }, (_, index) => {
    const start = index * interval;
    // Preserve the existing same-day end-of-day label used by booking/slot control.
    const end = Math.min(start + interval, 1439);
    return `${formatTime(start)} - ${formatTime(end)}`;
  });
};
